import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { theme } from "./theme";
import styled from "styled-components";
import Home from "./pages/home";
import NotaryBook from "./pages/notaryBook";
import CreateSession from "./pages/createSession";
import ForgetPassword from "./pages/forget-password";
import ResetPassword from "./pages/reset-password";
import Login from "./pages/login";
import Register from "./pages/register";
import RegisterConfirmation from "./pages/register-confirmation";
import ConfirmSignUp from "./pages/confirm-signup";
import Impersonation from "./pages/impersonation";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast-styles.css";
import ProtectedLayout from "./components/ProtectedLayout";
import "react-datepicker/dist/react-datepicker.css";
import SessionRequest from "./pages/sessionRequest";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-export";
import GlobalStyle from "./GlobalStyle";
import AdminProtectedLayout from "./components/AdminProtectedLayout";
import Logs from "./pages/logs";
import OnboardOfficial from "./pages/onboard";
import GenerateTokenPage from "./pages/passkey";
import { AppDispatch, getAppointmentTypes } from "./store";
import { useDispatch } from "react-redux";

Amplify.configure(awsconfig);

declare global {
  interface Window {
    Persona: any;
  }
}

function App() {
  const dispatch = useDispatch<AppDispatch>();

  const fetchAppointmentTypes = async () => {
    await dispatch(getAppointmentTypes({}));
  }
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "zsiqchat";
    script.type = "text/javascript";
    script.innerHTML = `
      var $zoho = $zoho || {};
      $zoho.salesiq = $zoho.salesiq || {
        widgetcode: "7c523a5c79842dbaa88db98f4a53304c0b44fcc29f482fbc4b68d32c8b4926149d16705d9466aa0374c2264672b50e93",
        values: {},
        ready: function() {}
      };
      var d = document;
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.id = "zsiqscript";
      s.defer = true;
      s.src = "https://salesiq.zoho.com/widget";
      var t = d.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(s, t);
    `;
    document.body.appendChild(script);
    fetchAppointmentTypes();
    return () => {
      document.getElementById("zsiqchat")?.remove();
      document.getElementById("zsiqscript")?.remove();
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AppBox>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedLayout>
                <Home />
              </ProtectedLayout>
            }
          />
          <Route
            path="/createSession"
            element={
              <ProtectedLayout>
                <CreateSession />
              </ProtectedLayout>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register-confirmation" element={<RegisterConfirmation />} />
          <Route path="/impersonation" element={<AdminProtectedLayout><Impersonation /></AdminProtectedLayout>} />
          <Route path="/confirm-signup" element={<RegisterConfirmation />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/sessionRequests"
            element={
              <ProtectedLayout>
                <SessionRequest />
              </ProtectedLayout>
            }
          />
          <Route
            path="/notary/:notaryId"
            element={
              <ProtectedLayout>
                <SessionRequest />
              </ProtectedLayout>
            }
          />
          <Route
            path="/notaryBook"
            element={
              <ProtectedLayout>
                <NotaryBook />
              </ProtectedLayout>
            }
          />
          <Route
            path="/onboard"
            element={
              <ProtectedLayout>
                <OnboardOfficial />
              </ProtectedLayout>
            }
          />
          <Route
            path="/passkey"
            element={
              <ProtectedLayout>
                <GenerateTokenPage />
              </ProtectedLayout>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedLayout>
                <Logs />
              </ProtectedLayout>
            }
          />
          <Route
            path="/session/:sessionId"
            element={
              <ProtectedLayout>
                <Home />
              </ProtectedLayout>
            }
          />
        </Routes>
      </AppBox>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          padding: "25px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "20px"
        }}
        pauseOnHover
        toastClassName="toast-container"
      />
    </ThemeProvider>
  );
}

export default App;

const AppBox = styled.div`
  display: flex;
`;

const MainContent = styled.div`
  position: relative;
  display: flex;
  width: 92%;
  left: 8%;
`;
